import { Div } from '../../../../base/components/native/div'
import { Img } from '../../../../base/components/native/img'
import { EASE, HIDE, SHOW, Y } from '../../../../base/helpers/style'

export const FAQItem = (q: string, a:string) => {
    let state = false
    const base = Div()
    const question = Div(q)
    const answer = Div(a)
    const plus = Img('/images/plus-icon.svg', {width: 36})
    base.append(question, answer, plus)

    plus.el.onclick = () => {
        state = !state
        answer.style({ display: state ?  'block': 'none'}, state? 0: 0)
        answer.style(state? {...SHOW, ...Y(0)}: {...HIDE, ...Y(-20)}, 10)
        plus.style({ transform: state ? 'rotate(-135deg)': 'rotate(0deg)'})
    }

    question.cssClass({
        paddingRight: '22px',
        cursor: 'pointer',
        lineHeight: '22px',
        textAlign: 'left',
    })
    answer.cssClass({
        ...EASE(.16),
        ...Y(-20),
        ...HIDE,
        padding: '20px 20px 20px 0',
        display: 'none',
        color: '#6d6d6d',
    })
    plus.cssClass({
        ...EASE(.16),
        cursor: 'pointer',
        position: 'absolute',
        right: '0',
        top: '44px',
        fontWeight: '100',
        fontSize: '58px',
    })
    base.cssClass({
        position: 'relative',
        padding: '50px 0',
        borderBottom: '1px solid #DDDDDD',
        with: '100%',
        maxWidth: '980px',
        fontSize: '18px',
    })

    return base
}